import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

/* eslint-disable react/no-deprecated */
// ReactDOM.render is deprecated in React 18, but we are still using React 17 for now.
// createRoot can be used once we upgrade to React 18.
ReactDOM.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
    </BrowserRouter>,
    document.querySelector('#root')
);

// For catching and making pwa apps. read here :- https://create-react-app.dev/docs/making-a-progressive-web-app/
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
